<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="editPosition()" v-if="permission.addPosition && warehouseType == 0">{{
                    permission.addPosition
                }}</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printLabels()" v-if="permission.printLabels && warehouseType == 0">{{
                    permission.printLabels
                }}</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="batchAddSpaces()" v-if="permission.addPosition && warehouseType == 0"
                    >批量创建仓位</el-button
                >
                <el-button size="small" type="primary" class="search-btn" @click="batchZones()" v-if="permission.batchZoneRs && warehouseType == 0"
                    >{{ permission.batchZoneRs }}</el-button
                >
            </div>
            <div class="search-ctn-right">
                <div class="search-name">区域</div>
                <el-select v-model="searchData.ZoneId" class="search-item" size="small" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未关联区域" value="未关联区域"></el-option>
                    <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
                <div class="search-name">仓位</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Keyword" v-filter-special-char="searchData.Keyword" placeholder="仓位名称或编号"></el-input>
                <!-- <div class="search-name">创建时间</div>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :picker-options="startDateOps"
                    class="search-item"
                    size="small"
                    v-model="searchData.StartDate"
                    type="date"
                    placeholder="开始日期"
                ></el-date-picker>
                <div class="search-name">&nbsp;-&nbsp;</div>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :picker-options="endDateOps"
                    class="search-item"
                    size="small"
                    v-model="searchData.EndDate"
                    type="date"
                    placeholder="结束日期"
                ></el-date-picker> -->
                <div class="search-name">仓位状态</div>
                <el-select v-model="searchData.State" class="search-item" size="small" placeholder="请选择">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">仓位类型</div>
                <el-select v-model="searchData.SpaceType"  class="search-item" size="small" placeholder="请选择">
                    <el-option v-for="item in spaceTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                @selection-change="handleSelectionChange"
            >
                <el-table-column v-if="permission.printLabels" type="selection"></el-table-column>
                <el-table-column prop="ZoneName" label="设置区域"></el-table-column>
                <el-table-column label="仓位编号" min-width="200px">
                    <template slot-scope="scope">{{ scope.row.Code }} <span style="color: #8492a6" v-if="scope.row.StorageType == 1"> (前置仓)</span></template>
                </el-table-column>
                <el-table-column prop="Name" label="仓位名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="UseDesc" label="用途"></el-table-column>
                <el-table-column prop="GoodsQuantity" label="货物数量"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">{{ scope.row.SpaceType | spaceTypeHandle }} </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Remark" label="备注"></el-table-column>
                <el-table-column width="180px" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.editPosition && scope.row.StorageType == 0" title="编辑仓位" size="mini" type="text" @click="editPosition(scope.row)"
                                >编辑仓位</el-button
                            >
                            <el-button v-if="permission.saveGoods && scope.row.StorageType == 0" title="存放货物" size="mini" type="text" @click="saveGoods(scope.row)">{{
                                permission.saveGoods
                            }}</el-button>
                            <el-button
                                v-if="permission.printGoodsLabels && scope.row.StorageType == 0"
                                title="打印该仓位下的商品标签"
                                size="mini"
                                type="text"
                                @click="showPrintGoodsLabels(scope.row)"
                                >{{ permission.printGoodsLabels }}</el-button
                            >
                            <el-button
                                v-if="permission.delPosition && scope.row.StorageType == 0"
                                title="删除仓位"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="delPosition(scope.row)"
                                >{{ permission.delPosition }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50, 100, 150]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="更多条件"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-syslogs-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="区域">
                    <el-select v-model="searchData.ZoneId" class="search-item" style="width: 100%" size="small" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未关联区域" value="未关联区域"></el-option>
                        <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select> 
                    </el-form-item>
                    <el-form-item label="仓位">
                        <el-input class="search-item" size="small" style="width: 100%" v-model.trim="searchData.Keyword" v-filter-special-char="searchData.Keyword" placeholder="仓位名称或编号"></el-input>
                    </el-form-item>
                    <el-form-item label="仓位状态">
                        <el-select v-model="searchData.State" class="search-item" style="width: 100%" size="small" placeholder="请选择">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                    </el-form-item>
                    <el-form-item label="仓位类型">
                        <el-select v-model="searchData.SpaceType" class="search-item" style="width: 100%" size="small" placeholder="请选择">
                        <el-option v-for="item in spaceTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            size="small"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <!--    新增/编辑仓位    -->
        <el-dialog :close-on-click-modal="false" :title="editDialogTitle" :visible.sync="editVisible" width="800px">
            <div class="dialog-content" v-if="editVisible">
                <positionEdit :ShelfSpaceId="ShelfSpaceId" :WarehouseId="searchData.WarehouseId" @closeDialog="editClose"></positionEdit>
            </div>
        </el-dialog>
        <!--    存放货物    -->
        <el-dialog :close-on-click-modal="false" title="存放货物" :visible.sync="saveGoodsVisible" width="800px">
            <div class="dialog-content" v-if="saveGoodsVisible">
                <storeGoods :ShelfSpaceId="ShelfSpaceId" :WarehouseId="searchData.WarehouseId" @closeDialog="saveGoodsClose"></storeGoods>
            </div>
        </el-dialog>
        <!--    查看货物    -->
        <el-dialog :close-on-click-modal="false" title="仓位存放数据" :visible.sync="showVisible" width="1200px">
            <div class="dialog-content" v-if="showVisible">
                <goodShow :ShelfSpaceId="ShelfSpaceId" :WarehouseId="searchData.WarehouseId" @closeDialog="showClose"></goodShow>
            </div>
        </el-dialog>
        <!--    打印该仓位下的商品标签    -->
        <el-dialog :close-on-click-modal="false" title="打印该仓位下的商品标签" :visible.sync="showPrintLabelVisible" width="1200px">
            <div class="dialog-content" v-if="showPrintLabelVisible">
                <printSpaceGoodsLabels :ShelfSpaceId="ShelfSpaceId" :WarehouseId="searchData.WarehouseId" @closeDialog="closePrintDialog"></printSpaceGoodsLabels>
            </div>
        </el-dialog>
        <!--    批量关联区域    -->
        <el-dialog :close-on-click-modal="false" title="批量修改" :visible.sync="zoneVisible" width="500px">
            <div class="dialog-content" v-if="zoneVisible" v-loading="loading">
                <div class="flex">
                    <div class="item1">
                        <div class="item-lable">修改项</div>
                        <div>
                            <el-select v-model="zoneData.label" :disabled="false" class="search-item" size="small" placeholder="请选择">
                                <el-option label="设置区域" value="1"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item2">
                        <div class="item-lable">结果值</div>
                        <div>
                            <el-select style="width: 100%;" v-model="zoneData.value" class="search-item" size="small" placeholder="请选择">
                                <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="dialog-footer">
                    <el-button @click="cancel()">取消</el-button>
                    <el-button class="btn-primary" @click="BatchUpZoneRs">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import storeGoods from '@/components/business/goods/storeGoods';
import goodShow from '@/components/business/goods/goodShow';
import printSpaceGoodsLabels from '@/components/business/goods/printSpaceGoodsLabels';
import positionEdit from '@/components/business/goods/positionEdit';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        storeGoods,
        goodShow,
        positionEdit,
        breadcrumb,
        elTableColumn,
        printSpaceGoodsLabels
    },
    name: '',
    data() {
        return {
            ShelfSpaceId: '',
            startDateOps: {
                disabledDate: time => {
                    if (this.searchData.EndDate != '') {
                        return time.getTime() > new Date(this.searchData.EndDate);
                    }
                }
            },
            endDateOps: {
                disabledDate: time => {
                    if (this.searchData.StartDate != '') {
                        return time.getTime() <= new Date(this.$util.getOtherDay(this.searchData.StartDate, -1));
                    }
                }
            },
            stateList: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '正常使用' },
                { Value: '1', Text: '暂停使用' }
            ],
            spaceTypeList: [
                { Value: '', Text: '全部' },
                { Value: '0', Text: '标准仓' },
                { Value: '1', Text: '临时仓' },
                { Value: '2', Text: '废品仓' }
            ],
            warehouseName: '',
            warehouseType: 0,
            dialogTitle: '仓库信息',
            editVisible: false,
            editDialogTitle: '',
            saveGoodsVisible: false,
            showVisible: false,
            showPrintLabelVisible: false,
            searchData: {
                WarehouseId: '',
                Keyword: '',
                State: '',
                SpaceType: '',
                StartDate: '',
                EndDate: '',
                ZoneId:'',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            idList: [],
            multipleSelection: null,
            zoneVisible:false,
            zoneList:[],
            loading:false,
            zoneData:{
                label:"1",
                value:"",
            },
            datetime:[],
            dialogVisible:false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                disabledDate(time) {
                    const year = new Date().getFullYear(); // 获取当前年份
                    const mon = new Date().getMonth() + 1; // 获取当前月份份
                    const day = new Date().getDate(); // 获取当前日期
                    const oneYear = year - 1; // 获取去年
                    const timeYear = new Date(oneYear + '/' + mon + '/' + day).getTime(); // 将的日期转换成时间戳
                    return time.getTime() > Date.now() || time.getTime() <= timeYear;
                }
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.searchData.WarehouseId = this.$route.query.id;
        this.warehouseName = this.$route.query.warehouse;
        this.permission = this.$util.getPermission('warehouse');
        this.getTableData();
        this.getZoneList();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '暂停使用';
            }
        },
        spaceTypeHandle(value) {
            switch (value) {
                case 0:
                    return '标准仓';
                case 1:
                    return '临时仓';
                case 2:
                    return '废品仓';
                default:
                    return '未知';
            }
        }
    },
    methods: {
        // 关闭查看编辑仓位
        editClose(edit) {
            this.editVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        saveGoodsClose(edit) {
            this.saveGoodsVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        showClose() {
            this.showVisible = false;
        },
        editPosition(row) {
            this.ShelfSpaceId = '';
            this.editDialogTitle = this.warehouseName;
            if (row) {
                this.editDialogTitle = this.warehouseName + row.Name;
                this.ShelfSpaceId = row.ShelfSpaceId;
            }
            this.editVisible = true;
        },
        // 删除仓位
        delPosition(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该仓位吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpShelfSpaces/DeleteEnterpriseGoodsLocation',
                            data: {
                                WarehouseId: that.searchData.WarehouseId,
                                ShelfSpaceId: row.ShelfSpaceId,
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.searchData.page = 1;
                            that.getTableData();
                        });
                }
            });
        },
        saveGoods(row) {
            this.ShelfSpaceId = row.ShelfSpaceId;
            this.saveGoodsVisible = true;
        },
        resetSearch() {
            this.searchData = {
                WarehouseId: this.searchData.WarehouseId,
                Keyword: '',
                State: '',
                SpaceType: '',
                StartDate: '',
                EndDate: '',
                ZoneId:'',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.warehouseType = data.WarehouseType;
                    this.tableData = data.GoodsLocationList;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.ShelfSpaceId = event.ShelfSpaceId;
                this.showVisible = true;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].ShelfSpaceId);
            }
            this.idList = idList;
        },
        // 打印
        printLabels() {
            if (this.idList.length < 1) {
                this.$util.warningMsg('请选择仓位进行打印');
                return;
            } else {
                //传到接口调用打印出来
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoodsLabels/PrintLocationLabels',
                        data: {
                            Ids: this.idList
                        }
                    })
                    .then(() => {});
            }
        },
        closePrintDialog() {
            this.showPrintLabelVisible = false;
        },
        showPrintGoodsLabels(row) {
            this.ShelfSpaceId = row.ShelfSpaceId;
            this.showPrintLabelVisible = true;
        },
        batchAddSpaces() {
            this.$router.push(`/inventoryManage/batchAddSpaces?id=${this.searchData.WarehouseId}&name=${this.warehouseName}`);
        },
        batchZones(){
            this.zoneVisible = true;
            this.zoneData.value = "";
        },
        cancel(){
            this.zoneVisible = false;
            this.zoneData.value = "";
        },
        getZoneList() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneDataList',
                    data: {
                        WarehouseId: that.searchData.WarehouseId
                    }
                })
                .then(res => {
                    that.loading = false;
                    that.zoneList = res.data;
                });
        },
        BatchUpZoneRs() {
            let that = this;
            if(that.idList.length == 0){
                this.$util.elConfirm({
                    content: '未选择仓位，是否按查询条件更新所有仓位的区域？',
                    noMsg: true,
                    confirm() {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpShelfSpaces/BatchUpZoneRs',
                                data: {
                                    WarehouseId : that.searchData.WarehouseId,
                                    Id : that.zoneData.value,
                                    Key : that.searchData.Keyword,
                                    State2: that.searchData.State,
                                    SpaceType: that.searchData.SpaceType,
                                    StartDate: that.searchData.StartDate,
                                    EndDate: that.searchData.EndDate,
                                }
                            })
                            .then(res => {
                                if(res.errcode == 0){
                                    that.zoneVisible = false;
                                    that.$util.successMsg('修改成功');
                                    that.searchData.page = 1;
                                    that.getTableData();
                                }else
                                    that.$util.errorMsg(res.errmsg);
                                
                                that.loading = false;
                            });
                    }
                });
            }else{
                that.loading = true;
                that.$util
                    .axiosPost({
                        url: '/api/EntpShelfSpaces/BatchUpZoneRs',
                        data: {
                            WarehouseId : that.searchData.WarehouseId,
                            SSIds : that.idList,
                            Id : that.zoneData.value
                        }
                    })
                    .then(res => {
                        if(res.errcode == 0){
                            that.zoneVisible = false;
                            that.$util.successMsg('修改成功');
                            that.searchData.page = 1;
                            that.getTableData();
                        }else
                            that.$util.errorMsg(res.errmsg);
                        
                        that.loading = false;
    
                    });

            }

        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        }
    }
};
</script>
<style style lang="less" scoped>
.item1{
    width: 25%;
    height: 75px;
}
.item2{
    width: 70%;
    height: 75px;
    margin-left: 10px;
}
.item-lable{
    text-align: center;
}
.dialog-footer{
    display: flex;
    justify-content:flex-end;
}
.search-item-dialog .el-form-item {
    margin-bottom: 0;
}
</style>